<template>
  <!-- 首页Activities组件 -->
  <section id="company-activities" class="company-activities">
    <img src="../../assets/images/topline.png" class="topline" />

    <div class="imgDIV">
      <!-- <img src="../../assets/images/line.png" class="line" /> -->
      <img src="../../assets/images/Activities.png" class="imgtitle" />
      <!-- <img src="../../assets/images/topline.png" class="topline" /> -->
      <!-- <img src="../../assets/images/line.png" class="line" /> -->
    </div>
    <img src="../../assets/images/topline.png" class="topline" />
    <div class="activities">
      <div
        class="activity"
        v-for="(item, index) in activities"
        :key="index"
        @click="opento(item)"
      >
        <div class="act-image-wrapper">
          <el-image :src="`${filePreview}${item.cover}`" class="img"></el-image>
        </div>
        <h2 class="act-title" @click="test()">{{ item.date_title }}</h2>
        <div class="act-con">{{ item.title }}</div>
        <article class="act-content">
          {{ item.digest }}
        </article>
        <button class="read-more-btn" @click="opento(item)">Read More</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Activities',
  data() {
    return {
      filePreview: `${window._CONFIG['filePreview']}?fileId=`,
      activities: []
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      let url = `${window._CONFIG['domianURL']}/xmu/index/getData/36261a89badc4e0dbac011fcd18a6864?use_type=19`;
      this.$axios({
        method: 'get',
        url: url
      }).then(res => {
        let data = res.data.result.records.slice(0, 3);
        data.forEach(e => {
          e.api = '36261a89badc4e0dbac011fcd18a6864/' + e.id;
        });
        this.activities = data;
      });
    },
    test() {
      this.$axios
        .get(
          'https://mini.kingboya.com:10540/eoa/im/api/getList?userId=1483664524254736386&token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NDI1ODM4MjQsInVzZXJuYW1lIjoia2luZyJ9.oK5GVVVtY7A5MxDc-ydcO2_FqaTkGRQHvR9ELLGzJ2g&_=1642584621304'
        )
        .then(function (response) {
          // console.log(response);
        });
    },
    opento(item) {
      console.log(`url`, item.id);
      this.$router.push({
        path: '/Activities',
        query: {
          title: 'ACTIVITIES',
          code: item.api,
          id: item.id
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.company-activities {
  margin-top: -181px;
  position: relative;
  padding-bottom: 30px;
}

.act_bg {
  background-image: url('../../assets/images/activites-bg.png');
  background-size: 100% 100%;
}

.imgtitle {
  width: 400px;
  height: 80px;
  margin-bottom: 10px;
}

.act-image-wrapper {
  height: 195px;
  overflow: hidden;
  padding: 10px;
  background-color: #ffffff;
  box-shadow: 0px 0px 34px rgb(0 0 0 / 10%);
  margin: -24px -24px 10px;
}

.act-con {
  font-size: 18px;
  font-family: 'Oswald-Light';
  font-weight: bold;
  color: #000000;
  line-height: 36px;
  height: 150px;
}

.act-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  /*想省略几行就写几*/
  -webkit-box-orient: vertical;
  margin-top: 5px;
  margin-bottom: 25px;
  font-family: 'pala';
  font-size: 18px;
  color: #000;
}

.activity article {
  line-height: 27px;
  font-size: 18px;
}

// /deep/.activity
.read-more-btn {
  font-family: 'Oswald-Light';
}

/deep/.activity .read-more-btn {
  font-size: 19px;
  margin-bottom: 10px;
}

.act-title {
  color: #003a7e;
  font-size: 16px;
  margin-bottom: 8px;
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.topline {
  width: 1px;
  height: 60px;
  margin: 0 auto;
  // margin-bottom: 30px;
}

.imgDIV {
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: space-around;

  .line {
    height: 1px;
    width: 40%;
  }

  .bg {
    position: absolute;
    z-index: -1;
    margin-top: 280px;
    width: 100%;
    height: 70%;
  }
}

/deep/.el-image__inner {
  vertical-align: top;
  object-fit: contain;
}
</style>
